import { useConfig } from 'src/client/hoc/config';

export const useLocale = () => {
    const config = useConfig();
    if (!config?.locale) {
        return '';
    }

    return config.locale.replace('-', '_') || '';
};
